import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useState } from "react";
import AppPagesEnum from "../pages/appPagesEnum";
const PageContext = createContext({
    activePage: AppPagesEnum.DASHBOARD,
    setActivePage: () => { }
});
export const PageProvider = ({ children }) => {
    const [activePage, setActivePage] = useState(AppPagesEnum.DASHBOARD);
    return _jsx(PageContext.Provider, { value: { activePage, setActivePage }, children: children });
};
export default PageContext;
